import { Injectable } from '@angular/core'
import { UrlTree } from '@angular/router'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class CookieDisabledGuard {
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (navigator.cookieEnabled) {
      const { referrer } = window.document
      if (window.history.length > 1) {
        window.history.back()
      } else if (referrer) {
        window.location.href = referrer
      }
      return false
    }
    return true
  }
}
